let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7ljrx")).then(() => parcelRequire('kEs7r'));